import * as React from 'react'
import { observer } from 'mobx-react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderExtras,
} from 'components/StickyViewHeader'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import Button from 'components/Button'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import Workspace from 'iam/models/Workspace'
import AdminInventoryManagerViewModel from '../../InventoryManagerViewModel'
import { Dropdown, DropdownItem, DropdownTitle } from 'components/Dropdown'
import Icon from 'components/Icon'
import styles from './InventoryManagerHeader.sass'

interface InventoryManagerHeaderProps {
  scrollOffset: ScrollOffsetInterpolation
  vm: AdminInventoryManagerViewModel
}

export default observer(function InventoryManagerHeader({
  scrollOffset,
  vm,
}: InventoryManagerHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceSelectorViewHeading
          primaryText={'Service manager'}
          allOptionDropdownItem={
            vm.canManageGlobalInventory ? (
              <>
                Global inventory{' '}
                <span className={styles.inventoryCount}>
                  ({vm.globalInventoryCount})
                </span>
              </>
            ) : null
          }
          alwaysUseDropdown={vm.workspacesUseDropdown}
          workspaces={vm.workspaces}
          dropdownTitle="Select inventory"
          onChange={vm.selectWorkspaceForFiltering}
          searcher={vm.canSearch ? vm.workspaceSearcher : undefined}
          renderName={(workspace) => {
            return (
              <>
                {workspace.name}{' '}
                <span className={styles.inventoryCount}>
                  ({vm.getWorkspaceInventoryItemsCount(workspace)})
                </span>
              </>
            )
          }}
          allOptionText={
            vm.canManageGlobalInventory ? 'Global Inventory' : null
          }
          value={
            vm.workspaceFilter.type === 'Global'
              ? Workspace.none
              : vm.workspaceFilter.workspace
          }
        />
      </StickyViewHeaderMain>
      <StickyViewHeaderExtras>
        <AddInventoryItemDropdown vm={vm} />
      </StickyViewHeaderExtras>
    </StickyViewHeader>
  )
})

interface AddInventoryItemDropdownProps {
  vm: AdminInventoryManagerViewModel
}

const AddInventoryItemDropdown = ({ vm }: AddInventoryItemDropdownProps) => {
  return (
    <Dropdown
      button={
        <Button submit dataTest="add-inventory-item-dropdown">
          Add Service Item <Icon name="dropdown" size={14} />
        </Button>
      }
      position="bottom-start"
      autoDismiss
    >
      <DropdownTitle>Add new</DropdownTitle>
      {vm.canManageGlobalInventory && (
        <DropdownItem
          onClick={() => vm.createInventoryItemViewModel.open()}
          dataTest="add-global-inventory-item"
        >
          Global service item
        </DropdownItem>
      )}
      {vm.canManageWorkspaceInventory && (
        <DropdownItem
          onClick={() => vm.createWorkspaceInventoryItemViewModel.open()}
          dataTest="add-workspace-inventory-item"
        >
          Workspace service item
        </DropdownItem>
      )}
    </Dropdown>
  )
}
